import { useTranslation } from "react-i18next";
import { cn } from "@/lib/cn";
import { formatPrice } from "@/lib/formatters";

type ProductActionsProps = {
    quantity: number;
    price: number | null;
    productName: string;
    className?: string;
    onRemove?: () => void;
    removeTestId?: string;
};

export function ProductActions({
    quantity,
    price,
    productName,
    className,
    onRemove,
    removeTestId,
}: ProductActionsProps) {
    const { t } = useTranslation();

    return (
        <div className="flex items-center gap-3">
            <div className={cn("shrink-0 text-right", className)}>
                <p className="text-[10px] font-semibold uppercase tracking-wide text-primary">
                    {t("confirmStep.quantity", { count: quantity })}
                </p>
                {price != null && (
                    <p className="text-xl font-semibold text-gray-800">
                        {formatPrice(price)}
                    </p>
                )}
            </div>

            {onRemove && (
                <button
                    type="button"
                    data-testid={removeTestId}
                    onClick={onRemove}
                    aria-label={t("confirmStep.removeProduct", {
                        name: productName,
                    })}
                    className="shrink-0 text-gray-300 hover:text-red-400 transition-colors"
                >
                    <svg
                        className="size-5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={1.5}
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                        />
                    </svg>
                </button>
            )}
        </div>
    );
}
